import React from 'react';
import { Link } from 'react-router-dom';

const ForgotPassword: React.FC = () => {
    return (
        <>
            <div className="col-12 col-md-8 col-xl-6">
                <div className="h-100 py-4 px-md-3">
                    <div className="row h-100 align-items-center justify-content-center">
                        <div className="col-12 col-sm-8 col-md-11 col-xl-11 col-xxl-10 login-box">
                            <div className="card mb-3">
                                <div className="card-body">
                                    <div className="text-center mb-4">
                                        <h1 className="mb-1 text-theme-1">Sorry!</h1>
                                        <h4 className="mb-3">You have to be here</h4>
                                        <p className="text-secondary">Provide your registered email address, we will send you an email with change password link with steps.</p>
                                    </div>

                                    <div className="form-floating mb-3">
                                        <input type="email" className="form-control" id="emailadd" placeholder="Enter email address" defaultValue="info@adminuiux" autoFocus />
                                        <label htmlFor="emailadd">Email Address</label>
                                    </div>

                                    <Link to="/auth/change-password" className="btn btn-lg btn-theme w-100 mb-4">Reset Now</Link>
                                    <div className="text-center mb-3">
                                        Already have password? <Link to="/auth/login">Login</Link> here.
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default ForgotPassword;
